export const menuData = [
    {title: "About", link: "#aboutSection"},
    {title: "Works", link: "#worksSection"},
    {title: "Contact", link: "#contactSection"},
];